import { ref } from 'vue'

export const useEntity = <T>() => {
  const entities = ref<T[]>([])
  const selected = ref<T | null>(null)
  const meta = ref<Meta | null>(null)
  const links = ref<string[] | null>(null)
  const loading = ref<boolean>(false)
  const refetch = ref<boolean>(false)
  const notFound = ref<boolean>(false)

  return {
    entities,
    selected,
    meta,
    links,
    loading,
    refetch,
    notFound
  }
}
